module.exports = __webpack_public_path__ + "static/media/imgop_BBSRC-logo.2a418cd0.webp";